module.exports = __webpack_public_path__ + "img/a1.317734f4.png";